import React from 'react'
import { TableRow, TableCell, Skeleton, Box } from '@mui/material'

const EmployeeTableSkeleton = ({ rows = 5 }) => {
    return (
        <>
            {[...Array(rows)].map((_, index) => (
                <TableRow key={`emp-skeleton-${index}`}>
                    {/* Col 1: Employee ID */}
                    <TableCell><Skeleton width={60} /></TableCell>

                    {/* Col 2: Name (Avatar + Text) */}
                    <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Skeleton variant="circular" width={40} height={40} />
                            <Box>
                                <Skeleton width={120} />
                                <Skeleton width={80} />
                            </Box>
                        </Box>
                    </TableCell>

                    {/* Col 3: Gender */}
                    <TableCell><Skeleton width={60} /></TableCell>

                    {/* Col 4: Type */}
                    <TableCell><Skeleton width={60} /></TableCell>

                    {/* Col 5: Department */}
                    <TableCell><Skeleton width={80} /></TableCell>

                    {/* Col 6: Position */}
                    <TableCell><Skeleton width={100} /></TableCell>

                    {/* Col 7: Work Shift */}
                    <TableCell><Skeleton width={80} /></TableCell>

                    {/* Col 8: Face Enrollment */}
                    <TableCell><Skeleton width={80} /></TableCell>

                    {/* Col 9: Status */}
                    <TableCell><Skeleton width={60} /></TableCell>

                    {/* Col 10: Actions */}
                    <TableCell align="right">
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Skeleton variant="circular" width={32} height={32} />
                            <Skeleton variant="circular" width={32} height={32} />
                            <Skeleton variant="circular" width={32} height={32} />
                        </Box>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}

export default EmployeeTableSkeleton
